<template>
  <div
    ref="backgroundVideo"
    class="background-video"
    :class="{
      'background-video--iframe': config.video_type === 'video_url',
      'background-video--video': config.video_type === 'video_file',
      'background-video--playing': playing,
    }"
  >
    <div
      class="background-video__bg"
      :style="{
        backgroundImage: bgImg && `url(${bgImg})`,
      }"
    >
      <youtube
        v-if="videoId && config.video_type === 'video_url'"
        class="background-video__video"
        :video-id="videoId"
        ref="youtube"
        :player-vars="playerVars"
        @ready="ready"
        @error="error"
      />
      <video
        loop
        ref="localVideo"
        v-else-if="videoFile.url && config.video_type === 'video_file'"
        class="background-video__video"
        :controls="false"
        :muted="isMute"
        @canplay="ready"
        @error="error"
        :poster="videoFile.thumbnail"
      >
        <source :src="videoFile.url" />
        Your device does not support video
      </video>

      <!-- 封面 -->
      <v-lazy-img class="background-video__poster" v-if="image.url" :dataSrc="image.thumbnail"  :data-url="image.url" />
    </div>

    <div class="background-video__content" :class="`background-video__content--${layoutClass[config.layout]}`">
      <div class="video-content">
        <p v-if="config.description" class="video-content__sub-title">{{ config.description }}</p>
        <p
          v-if="config.title"
          :style="{
            'font-size': `${config.title_size}px`,
          }"
          class="video-content__title"
        >
          {{ config.title }}
        </p>
        <p v-if="config.text" class="video-content__text">{{ config.text }}</p>

        <div class="video-content__button-wrapper">
          <div v-for="(item, index) in buttonConfig" :key="index">
            <a
              class="home-btn video-content__button"
              :style="{
                '--btn-bg-color': config.button_background_color,
                '--btn-color': config.button_text_color,
              }"
              v-if="item.url && item.text"
              :href="item.url"
              >{{ item.text }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 视屏控制部分 -->
    <div v-if="config.show_controls && isReady" class="background-video__controls">
      <a v-show="isPushe" @click="play">
        <i class="iconfont icon-cm-bofang" />
      </a>
      <a v-show="!isPushe" @click="pushe">
        <i class="iconfont icon-cm-zanting" />
      </a>
      <a v-show="isMute" @click="unMute">
        <i class="iconfont icon-cm-jingyin" />
      </a>
      <a v-show="!isMute" @click="mute">
        <i class="iconfont icon-cm-shengyin" />
      </a>
    </div>
  </div>
</template>

<script>
//import LazyImg from '@/js/components/LazyImg.vue'
import VueYoutube from 'vue-youtube'
import defaultBgImg from '@/images/defaultBanner.jpg'
import { urlToQueryData } from '@/js/lib/util'

Vue.use(VueYoutube)
export default {
  // components: { LazyImg },
  name: 'backgroundVideo',
  props: {
    config: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      image: this.config.image || {},
      buttonConfig: this.config.button || [],
      bgImg: null, // 默认背景, 没有上传背景图和视频时显示
      videoId: null,
      playing: false, // 开始播放
      isPushe: true, // 暂停
      isMute: true, // 静音
      isReady: false,
      videoFile: this.config.video_file || {}, // 本地上传的视频
      // youtube视频播放参数
      playerVars: {
        autoplay: 0,
        loop: 1,
        rel: 0,
        hd: 1,
        showinfo: 0,
        color: 'white',
        controls: 0,
        mute: 1,
        modestbranding: 1,
        vq: 720,
      },
      layoutClass: {
        left: 'middle-left',
        center: 'middle-center',
        right: 'middle-right',
        bottom_center: 'bottom-center',
        bottom_left: 'bottom-left',
        bottom_right: 'bottom-right',
      },
    }
  },
  mounted() {
    const { video_type, video_url, video_file, image } = this.config
    // 如果是iframe视频
    if (video_type === 'video_url') {
      // 获取youtube的视频id
      this.getYoutubeId(video_url)

      if (!this.videoId && !image?.url) {
        this.bgImg = defaultBgImg
      }
    } else {
      if (!video_file?.url && !image?.url) {
        this.bgImg = defaultBgImg
      }
    }

    // 添加滚动监听事件
    window.addEventListener('scroll', this.windowScroll)
  },
  methods: {
    /**
     * get youtubeid
     * 获取youtube的id
     * url的最后一段数据就是
     * 还有一种格式是watch?v=123456
     * */
    getYoutubeId(url) {
      if (!url) {
        this.videoId = null
        return
      }

      const urlData = urlToQueryData(url)

      this.videoId = urlData?.query?.v || urlData.pathName || null;
      this.playerVars.playlist = this.videoId
    },
    windowScroll() {
      const top = this.$refs.backgroundVideo.offsetTop
      const height = document.documentElement.clientHeight
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      // 滚动到指定位置，开始播放视频
      if (scrollTop + height - 100 > top && this.isReady) {
        this.play()
        // 成功播放后，移除监听
        window.removeEventListener('scroll', this.windowScroll)
      }
    },
    // 播放
    play() {
      if (this.isReady) {
        this.playing = true
        this.isPushe = false
        if (this.config.video_type === 'video_url') {
          this.player.playVideo()
        } else {
          this.$refs.localVideo.play()
        }
      }
    },
    // 暂停播放
    pushe() {
      this.isPushe = true
      if (this.config.video_type === 'video_url') {
        this.player.pauseVideo()
      } else {
        this.$refs.localVideo.pause()
      }
    },
    // 静音
    mute() {
      this.isMute = true
      if (this.config.video_type === 'video_url') {
        this.player.mute()
      }
    },
    // 取消静音
    unMute() {
      this.isMute = false
      if (this.config.video_type === 'video_url') {
        this.player.unMute()
      }
    },
    // 视屏加载结束
    ready(event) {
      this.isReady = true

      // 滚动监听
      this.windowScroll()
    },
    // 加载失败
    error(event) {
      this.playing = false
      this.isReady = false
    },
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.windowScroll)
  },
}
</script>

<style lang="scss" scoped>
.background-video {
  position: relative;
  overflow: hidden;
  &::v-deep {
    .background-video {
      &__video {
        height: 100%;
        width: 100%;
      }
    }
  }
  &__bg {
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    z-index: 0;
    background-size: cover;
    video {
       object-fit: cover;
    }
  }
  &__poster {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    transition: all 0.2s;
    object-fit: cover;
  }
  &__content {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    color: #fff;
    justify-content: center;
    align-items: center;
    padding-left: 40px;
    padding-right: 40px;
    overflow: visible;
    z-index: 3;
    .video-content {
      display: inline-block;
      width: 490px;
      max-width: 100%;
      text-align: center;
      padding-bottom: -20px;
      &__sub-title {
        font-size: 14px;
        line-height: 20px;
        font-family: var(--subtitle-font-family);
      }
      &__title {
        font-family: var(--title-font-family);
        line-height: 1.6;
        margin-top: 16px;
      }
      &__text {
        font-family: var(--text-font-family);
        font-size: 18px;
        line-height: 25px;
        margin-top: 16px;
      }
      &__button-wrapper {
        margin-top: 20px;
        margin-bottom: -20px;
        margin-left: -10px;
        margin-right: -10px;
        & > div {
          padding-right: 10px;
          padding-left: 10px;
          max-width: 100%;
          display: inline-block;
        }
      }
      &__button {
        max-width: 100%;
        display: inline-block;
        padding: 12px 20px;
        line-height: 22px;
        font-size: 16px;
        margin-bottom: 20px;
      }
    }
    &--middle-left {
      justify-content: start;
      .video-content {
        text-align: left;
      }
    }
    &--middle-right {
      justify-content: flex-end;
      .video-content {
        text-align: right;
      }
    }
    &--bottom-left {
      justify-content: start;
      align-items: flex-end;
      .video-content {
        text-align: left;
        margin-bottom: 100px;
      }
    }
    &--bottom-center {
      align-items: flex-end;
      .video-content {
        margin-bottom: 100px;
      }
    }
    &--bottom-right {
      align-items: flex-end;
      justify-content: flex-end;
      .video-content {
        text-align: right;
        margin-bottom: 100px;
      }
    }
  }
  &__controls {
    position: absolute;
    right: 60px;
    bottom: 40px;
    margin-right: -6px;
    z-index: 4;
    a {
      display: inline-block;
      cursor: pointer;
      color: #555;
      height: 34px;
      width: 34px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #fff;
      transition: all 0.2s;
      margin-left: 6px;
      margin-right: 6px;
      padding: 0;
      i {
        font-size: 12px;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &:hover {
        color: #000;
      }
    }
  }
  &--playing {
    .background-video {
      &__poster {
        opacity: 0;
        z-index: -4;
        color: #fff;
      }
    }
  }
  &--iframe {
    height: 0;
    padding-bottom: 56.25%;
    ::v-deep {
      .background-video {
        &__video {
          height: calc(100% + 500px);
          width: 100%;
        }
      }
    }
  }
  &--video {
    height: 840px;
  }

  @media screen and (max-width: 767px) {
    .video-content {
      max-width: 100%;
      &__button-wrapper {
        margin-bottom: -10px;
      }
      &__button {
        margin-bottom: 10px;
      }
    }
    &--video {
      height: 560px;
    }
    &--iframe {
      height: 560px;
      padding-bottom: 0;
      .background-video {
        &__bg {
          // display: grid;
          justify-content: center;
        }
      }
      ::v-deep {
        .background-video {
          &__video {
            width: 1000px;
            height: calc(100% + 500px);
            position: absolute;
            top: -250px;
            left: calc((1000px - 100vw) / -2);
          }
        }
      }
    }
    &__content {
      padding-left: 20px;
      padding-right: 20px;
      &__sub-title {
        font-size: 12px;
      }
    }
    &__controls {
      right: 20px;
      bottom: 40px;
    }
  }
}
</style>
